(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6863732a129f31be510873e3";
              window.beaePageSetting.pageTitle = "Découvrez notre lieu de yoga à Hossegor – Yoga Searcher"; 
              window.beaePageSetting.pageType = "page";

          let js_P4SAVSBF = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-eq1nu9clsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eq1nu9cl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eq1nu9cl');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eq1nu9cl: ', ex)
      };
    

      try {
        let argid = 'beae-v2kst74dblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-v2kst74d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-v2kst74d');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-v2kst74d: ', ex)
      };
    

      try {
        let argid = 'beae-q9mk26josection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-q9mk26jo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-q9mk26jo');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-q9mk26jo: ', ex)
      };
    

      try {
        let argid = 'beae-vuwzs86dblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vuwzs86d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vuwzs86d');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vuwzs86d: ', ex)
      };
    

      try {
        let argid = 'beae-zyege7hdblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zyege7hd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zyege7hd');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zyege7hd: ', ex)
      };
    

      try {
        let argid = 'beae-0oxieur1section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0oxieur1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0oxieur1');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0oxieur1: ', ex)
      };
    

      try {
        let argid = 'beae-noboha3lblock-counter',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-noboha3l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-noboha3l');
        args.el = args.els[0];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-noboha3l: ', ex)
      };
    

      try {
        let argid = 'beae-uacaxp7fblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-uacaxp7f',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-uacaxp7f');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-uacaxp7f: ', ex)
      };
    

      try {
        let argid = 'beae-mnr0865vblock-counter',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mnr0865v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mnr0865v');
        args.el = args.els[0];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mnr0865v: ', ex)
      };
    

      try {
        let argid = 'beae-i4mn0xicblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-i4mn0xic',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-i4mn0xic');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-i4mn0xic: ', ex)
      };
    

      try {
        let argid = 'beae-uatx3q38block-counter',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-uatx3q38',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-uatx3q38');
        args.el = args.els[0];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-uatx3q38: ', ex)
      };
    

      try {
        let argid = 'beae-xgj0kpdhblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xgj0kpdh',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xgj0kpdh');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xgj0kpdh: ', ex)
      };
    

      try {
        let argid = 'beae-9h7tamx8block-counter',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9h7tamx8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9h7tamx8');
        args.el = args.els[0];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9h7tamx8: ', ex)
      };
    

      try {
        let argid = 'beae-n196q94mblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n196q94m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n196q94m');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n196q94m: ', ex)
      };
    

      try {
        let argid = 'beae-gp3opn4rblock-counter',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gp3opn4r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gp3opn4r');
        args.el = args.els[0];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gp3opn4r: ', ex)
      };
    

      try {
        let argid = 'beae-2cq37zb2block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2cq37zb2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2cq37zb2');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2cq37zb2: ', ex)
      };
    

      try {
        let argid = 'beae-unc0q2v8section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-unc0q2v8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-unc0q2v8');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-unc0q2v8: ', ex)
      };
    

      try {
        let argid = 'beae-2dfqsc93section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2dfqsc93',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2dfqsc93');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2dfqsc93: ', ex)
      };
    

      try {
        let argid = 'beae-7upgu95oblock-counterloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7upgu95o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7upgu95o');
        args.el = args.els[0];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7upgu95o: ', ex)
      };
    

      try {
        let argid = 'beae-g8hihehgblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g8hihehg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g8hihehg');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g8hihehg: ', ex)
      };
    

      try {
        let argid = 'beae-7upgu95oblock-counterloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7upgu95o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7upgu95o');
        args.el = args.els[1];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7upgu95o: ', ex)
      };
    

      try {
        let argid = 'beae-g8hihehgblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g8hihehg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g8hihehg');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g8hihehg: ', ex)
      };
    

      try {
        let argid = 'beae-7upgu95oblock-counterloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7upgu95o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7upgu95o');
        args.el = args.els[2];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7upgu95o: ', ex)
      };
    

      try {
        let argid = 'beae-g8hihehgblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g8hihehg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g8hihehg');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g8hihehg: ', ex)
      };
    

      try {
        let argid = 'beae-7upgu95oblock-counterloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7upgu95o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7upgu95o');
        args.el = args.els[3];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7upgu95o: ', ex)
      };
    

      try {
        let argid = 'beae-g8hihehgblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g8hihehg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g8hihehg');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g8hihehg: ', ex)
      };
    

      try {
        let argid = 'beae-7upgu95oblock-counterloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7upgu95o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7upgu95o');
        args.el = args.els[4];
        ((h) => { let p=h.el.querySelector(".beae-x-counter--number"),f=h.el.querySelector(".beae-x-counter--prefix"),m=h.el.querySelector(".beae-x-counter--suffix"),w=!1;function g(){let $=null;switch(h.thousandSeparator){case"dot":$=".";break;case"space":$=" ";break;case"none":$="";break;default:$=",";break}return $}function _($,B,k){let x=null;if(x&&clearInterval(x),$===B)return!1;isNaN($)&&($=0),isNaN(B)&&(B=-1),isNaN(k)&&(k=1e3);let M=B-$,L=$,V=B>$?1:-1,T=Math.abs(Math.floor(k/M));x=setInterval(()=>{L+=V,p&&(p.innerHTML=L.toString().replace(/\B(?=(\d{3})+(?!\d))/g,g())),L==B&&clearInterval(x)},T)}function C(){if(w===!0)return!1;if(!S(p))return new IntersectionObserver((B,k)=>{B.forEach(x=>{x.isIntersecting&&(C(),k.unobserve(x.target))})},{root:null,rootMargin:"0px",threshold:.1}).observe(p),!1;_(h.start,h.end,h.duration),w=!0}function S($){let B=window.scrollY||window.pageYOffset,k=$.getBoundingClientRect().top+B,x={top:B,bottom:B+window.innerHeight},M={top:k,bottom:k+$.clientHeight};return M.bottom>=x.top&&M.bottom<=x.bottom||M.top<=x.bottom&&M.top>=x.top}C(),f&&h.numberPrefix&&(f.innerHTML=h.numberPrefix.toString()),m&&h.numberSuffix&&(m.innerHTML=h.numberSuffix.toString()) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7upgu95o: ', ex)
      };
    

      try {
        let argid = 'beae-g8hihehgblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g8hihehg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g8hihehg');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g8hihehg: ', ex)
      };
    

      try {
        let argid = 'beae-t0c59s64section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-t0c59s64',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-t0c59s64');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-t0c59s64: ', ex)
      };
    

      try {
        let argid = 'beae-t01l8ud1block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-t01l8ud1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-t01l8ud1');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-t01l8ud1: ', ex)
      };
    

      try {
        let argid = 'beae-wkl4o6m5block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wkl4o6m5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wkl4o6m5');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wkl4o6m5: ', ex)
      };
    

      try {
        let argid = 'beae-gue4koz9block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gue4koz9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gue4koz9');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gue4koz9: ', ex)
      };
    

      try {
        let argid = 'beae-szqfv5xbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-szqfv5xb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-szqfv5xb');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-szqfv5xb: ', ex)
      };
    

      try {
        let argid = 'beae-iayt780tblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-iayt780t',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-iayt780t');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-iayt780t: ', ex)
      };
    

      try {
        let argid = 'beae-cn3ynufkblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cn3ynufk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cn3ynufk');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cn3ynufk: ', ex)
      };
    

      try {
        let argid = 'beae-lsf3f7qtblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lsf3f7qt',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lsf3f7qt');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lsf3f7qt: ', ex)
      };
    

      try {
        let argid = 'beae-q2eu6qzysection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-q2eu6qzy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-q2eu6qzy');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-q2eu6qzy: ', ex)
      };
    

      try {
        let argid = 'beae-itlgojdlblock-video',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-itlgojdl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-itlgojdl');
        args.el = args.els[0];
        ((data) => { if(data.mode.value==="builder")return;if(data.source=="self hosted"&&data.el.querySelector(".beae_video")&&data.mute){const f=data.el.querySelector(".beae_video");f.muted=!0,f.play().catch(m=>{console.warn("Autoplay bị chặn:",m)})}const playButton=data.el.querySelector(".beae-video_overlay-icon"),playIcon=playButton&&playButton.querySelector(".beae-video-icon-play"),closePlayingButton=data.el.querySelector(".beae-close-video"),closeVideoFn=()=>{let f=playButton.closest(".beae-grid-block"),m=data.el.querySelector(".beae-x-video--wrapper");m&&m.classList.remove("playing"),f&&(f.style.zIndex=""),data.lightbox&&(document.querySelector("div.beae-builder")&&(document.querySelector("div.beae-builder").style.zIndex=""),f&&f.setAttribute("style",""),document.body.style.overflow="",document.documentElement.style.overflow="");let w=data.el.querySelector(".beae_video");w&&(w.autoplay=!1,w.pause());let g=data.el.querySelector(".beae_iframe");g&&g.getAttribute("src").indexOf("&autoplay=1")>-1&&g.setAttribute("src",g.getAttribute("src").replace("&autoplay=1",""))};if(playButton&&(playIcon&&playIcon.addEventListener("click",e=>{if(data.source=="self hosted"){let f=data.el.querySelector(".beae_video");f.autoplay=!0,f.load(),playButton.classList.remove("beae-overlay"),data.play_icon&&(data.el.querySelector(".beae-video-icon-play").style.display="none")}else{let f=data.el.querySelector(".beae_iframe"),m=f.getAttribute("src")+"&autoplay=1";f.setAttribute("src",m),playButton.classList.remove("beae-overlay"),data.play_icon&&(data.el.querySelector(".beae-video-icon-play").style.display="none")}let gridBlock=playButton.closest(".beae-grid-block"),wrapper=data.el.querySelector(".beae-x-video--wrapper");if(wrapper&&wrapper.classList.add("playing"),gridBlock&&(gridBlock.style.zIndex=1e8),data.lightbox){let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(f){extOptions={},console.error(f)}window.BeaePopupLibrary.createPopup(data.el.querySelector(".beae-block_video-player"),{width:"1070px",sectionId:data.id,...extOptions}),closeVideoFn()}}),closePlayingButton&&closePlayingButton.addEventListener("click",closeVideoFn)),["youtube","vimeo"].includes(data.source)&&(data.autoplay||data.loop)){let f=data.el.querySelector(".beae_iframe"),m={isloop:data.loop,autoplay:data.autoplay,idBlock:data.uniqueId||data.id,controls:data.player_controls?1:0};if(data.source=="youtube"){const w=/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;let g=data.srcYoutube.match(w),_=g&&g[2].length===11?g[2]:null;const C=/[?&]t=(\d+)s/,S=data.srcYoutube.match(C),$=S?S[1]:0;m.start=$,m.id=_,m.src=location.protocol+"//www.youtube.com/embed/"+_}switch(data.source){case"youtube":setTimeout(()=>{window.BEAEVIDEO.handleLoopYoutube&&window.BEAEVIDEO.handleLoopYoutube(m,data.uniqueId||data.id)});break;case"vimeo":setTimeout(()=>{window.BEAEVIDEO.handleLoopVimeo&&window.BEAEVIDEO.handleLoopVimeo(m,f)});break}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-itlgojdl: ', ex)
      };
    

      try {
        let argid = 'beae-q8hq0v2lblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-q8hq0v2l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-q8hq0v2l');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-q8hq0v2l: ', ex)
      };
    

      try {
        let argid = 'beae-99ljte17block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-99ljte17',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-99ljte17');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-99ljte17: ', ex)
      };
    

      try {
        let argid = 'beae-lo2sxrqxsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lo2sxrqx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lo2sxrqx');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lo2sxrqx: ', ex)
      };
    

      try {
        let argid = 'beae-205rg176block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-205rg176',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-205rg176');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-205rg176: ', ex)
      };
    

      try {
        let argid = 'beae-f5d7dlzusection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f5d7dlzu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f5d7dlzu');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f5d7dlzu: ', ex)
      };
    

      try {
        let argid = 'beae-f70vt4l3section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f70vt4l3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f70vt4l3');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f70vt4l3: ', ex)
      };
    

      try {
        let argid = 'beae-nkeag8iusection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nkeag8iu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nkeag8iu');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nkeag8iu: ', ex)
      };
    

      try {
        let argid = 'beae-sbis9l4wsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sbis9l4w',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sbis9l4w');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sbis9l4w: ', ex)
      };
    

      try {
        let argid = 'beae-bla678nhsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bla678nh',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bla678nh');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bla678nh: ', ex)
      };
    

      try {
        let argid = 'beae-a0ufmojysection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-a0ufmojy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-a0ufmojy');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-a0ufmojy: ', ex)
      };
    

      try {
        let argid = 'beae-zxbqg3uoblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zxbqg3uo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zxbqg3uo');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){X(ee)},q.ontouchmove=function(ee){X(ee)}}function Y(){D=0,check=!0}function X(oe){if(D==0)return!1;j=ae(oe),j<0&&(j=0),j>100&&(j=100),Q(j)}function ae(oe){const ee=q.getBoundingClientRect(),de=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(de*100/Z)))}function Q(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zxbqg3uo: ', ex)
      };
    

      try {
        let argid = 'beae-oiqth6ayblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oiqth6ay',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oiqth6ay');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oiqth6ay: ', ex)
      };
    

      try {
        let argid = 'beae-wjc043l8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wjc043l8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wjc043l8');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wjc043l8: ', ex)
      };
    

      try {
        let argid = 'beae-ma3yhxqiblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ma3yhxqi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ma3yhxqi');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){X(ee)},q.ontouchmove=function(ee){X(ee)}}function Y(){D=0,check=!0}function X(oe){if(D==0)return!1;j=ae(oe),j<0&&(j=0),j>100&&(j=100),Q(j)}function ae(oe){const ee=q.getBoundingClientRect(),de=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(de*100/Z)))}function Q(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ma3yhxqi: ', ex)
      };
    

      try {
        let argid = 'beae-fa7gdq6iblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fa7gdq6i',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fa7gdq6i');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fa7gdq6i: ', ex)
      };
    

      try {
        let argid = 'beae-y72op4x6block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-y72op4x6',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-y72op4x6');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-y72op4x6: ', ex)
      };
    

      try {
        let argid = 'beae-dqn6sllgblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-dqn6sllg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-dqn6sllg');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){X(ee)},q.ontouchmove=function(ee){X(ee)}}function Y(){D=0,check=!0}function X(oe){if(D==0)return!1;j=ae(oe),j<0&&(j=0),j>100&&(j=100),Q(j)}function ae(oe){const ee=q.getBoundingClientRect(),de=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(de*100/Z)))}function Q(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-dqn6sllg: ', ex)
      };
    

      try {
        let argid = 'beae-vutd3q68block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vutd3q68',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vutd3q68');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vutd3q68: ', ex)
      };
    

      try {
        let argid = 'beae-enq2ru66block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-enq2ru66',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-enq2ru66');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-enq2ru66: ', ex)
      };
    

      try {
        let argid = 'beae-1xqs93f3section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1xqs93f3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1xqs93f3');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1xqs93f3: ', ex)
      };
    

      try {
        let argid = 'beae-h63zqgseblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h63zqgse',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h63zqgse');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h63zqgse: ', ex)
      };
    

      try {
        let argid = 'beae-8gsbrwapsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8gsbrwap',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8gsbrwap');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8gsbrwap: ', ex)
      };
    

      try {
        let argid = 'beae-8gsbrwapsection-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8gsbrwap',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8gsbrwap');
        args.el = args.els[0];
        ((data
) => { function newsletterFocusHandle() {
  const formFields = data.el.querySelectorAll('.beae-form-field');
  const inputWrapper = data.el.querySelector('.beae-form-container');

  if (formFields.length === 0 || inputWrapper == null) return;

  formFields.forEach((formField) => {
    const input = formField.querySelector('input, textarea');

    if (!input) return;

    input.addEventListener('focus', () => {
      inputWrapper.classList.add('beae-user-focus'); 
      formField.classList.add('active'); 
    });

    input.addEventListener('blur', () => {
      if (input.value == '') { 
        formField.classList.remove('active'); 
      }
    });
  });
}

newsletterFocusHandle(); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8gsbrwap: ', ex)
      };
    

      try {
        let argid = 'beae-ht109403block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ht109403',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ht109403');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ht109403: ', ex)
      };
    

      try {
        let argid = 'beae-d9glatyxblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d9glatyx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d9glatyx');
        args.el = args.els[0];
        ((b) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,p=b.el.querySelector("form");b.el.querySelector(".beae-btn-pr");const f=b.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),m=b.el.querySelector(".btn-lightbox-form > button");!h&&b.mode.value!=="builder"&&(b.el.querySelector(".beae-form-success-message").style="display: none"),h&&b.afterSubmitting=="redirect"&&b.redirect&&(b.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=b.redirect);const w=[];p&&p.addEventListener("submit",g=>{g.preventDefault();for(let _=0;_<f.length;_++)w.push({fieldKey:f[_].name,fieldType:f[_].type,fieldValue:f[_].value})}),m&&(m.onclick=()=>{const g=document.createElement("div");g.innerHTML=p.outerHTML||"",window.BeaePopupLibrary.createPopup(g,{layout:"center",layoutMobile:"bottom",width:"500px",id:b.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d9glatyx: ', ex)
      };
    

      try {
        let argid = 'beae-n15b66e7section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n15b66e7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n15b66e7');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n15b66e7: ', ex)
      };
    }; if (window.BEAEBASE) {js_P4SAVSBF()} else {window.BEAEPAGEJS.push(js_P4SAVSBF)} })(); 